import type { PaletteMaterialSlot } from "building-types/materials/paletteMaterialSlotTypes";
import type { UVTransformation } from "geom/uv";

export function hashMaterialWithUV(material?: PaletteMaterialSlot, materialTransformation?: UVTransformation): string {
  return [
    material,
    materialTransformation?.uTranslation.toString(),
    materialTransformation?.vTranslation.toString(),
    materialTransformation?.rotationDegrees.toString(),
  ].join(".");
}
